import { TrackingPayload } from "./tracking-payload.interface";

export class AddPaymentInfoPayload implements TrackingPayload {
    constructor(
        public paymentMethod: string,
    ) { }

    public toMetaFormat(): Record<string, any> {

        return {
            payment_method: this.paymentMethod,
        };
    }
}